import Svg from 'components/atoms/structure/Svg';
import React from 'react';
import { getSystemImageUrl } from 'utils/assets';

import { Container, ImageContainer } from './styles';

import InfoLogLevel from 'components/molecules/containers/InfoLogLevel';
import { getFallbackUrl } from '../../../../utils/general';
import PropTypes from 'prop-types';
import { LevelType } from 'types/data/level';
import { useSelector } from 'react-redux';

const Level2LevelModal = ({ level, levelConquered }) => {
    const auth = useSelector((state) => state.auth);
    const coursesCompleted = auth?.user?.coursesCompleted || [];
    const completedCourseIds = coursesCompleted.map((course) => course.id);
    const data = [
        {
            id: 88,
            active: completedCourseIds.includes(88) || levelConquered,
            title: 'Arte da Comunicação',
            url: getFallbackUrl('/aluno/cursos/curso/88', 'Perfil')
        },
        {
            id: 94,
            active: completedCourseIds.includes(94) || levelConquered,
            title: 'Gerações',
            url: getFallbackUrl('/aluno/cursos/curso/94', 'Perfil')
        },
        {
            id: 93,
            active: completedCourseIds.includes(93) || levelConquered,
            title: 'Modelos Mentais',
            url: getFallbackUrl('/aluno/cursos/curso/93', 'Perfil')
        },
        {
            id: 89,
            active: completedCourseIds.includes(89) || levelConquered,
            title: 'Inteligência Emocional',
            url: getFallbackUrl('/aluno/cursos/curso/89', 'Perfil')
        },
        {
            id: 87,
            active: completedCourseIds.includes(87) || levelConquered,
            title: 'Marketing Pessoal',
            url: getFallbackUrl('/aluno/cursos/curso/87', 'Perfil')
        },
        {
            id: 105,
            active: completedCourseIds.includes(105) || levelConquered,
            title: 'A arte de mostrar a essência',
            url: getFallbackUrl('/aluno/cursos/curso/105', 'Perfil')
        },
        {
            id: 108,
            active: completedCourseIds.includes(108) || levelConquered,
            title: 'Tomadas de decisão com base em dados',
            url: getFallbackUrl('/aluno/cursos/curso/108', 'Perfil')
        },
        {
            id: 110,
            active: completedCourseIds.includes(110) || levelConquered,
            title: 'IA & Inovação',
            url: getFallbackUrl('/aluno/cursos/curso/110', 'Perfil')
        },
        {
            id: 107,
            active: completedCourseIds.includes(107) || levelConquered,
            title: 'Liderança e gestão com Bernardinho',
            url: getFallbackUrl('/aluno/cursos/curso/107', 'Perfil')
        }
    ];
    return (
        <Container>
            <p>Desafio: </p>

            <h2>Conclua os cursos</h2>
            <span>Faça os cursos</span>

            <InfoLogLevel data={data} />
        </Container>
    );
};

Level2LevelModal.propTypes = {
    level: PropTypes.shape(LevelType),
    levelConquered: PropTypes.bool
};

export default Level2LevelModal;
